import type { Vec3 } from '../types';

export const GRID_SNAP_MM = 10;
export const GRID_DISPLAY_MM = 100;
export const GROUND_LINE_SNAP_MM = 50;

export const lineSnapStep = (heightMm: number, enabled: boolean, gridSizeMm: number) =>
  enabled ? (Math.abs(heightMm) < 0.001 ? GROUND_LINE_SNAP_MM : gridSizeMm) : 1;

export const snapGridCoordinate = (value: number, origin: number, step = GRID_SNAP_MM) =>
  origin + Math.round((value - origin) / step) * step;

/** Finite grid lines locked to the project origin. Coordinates are returned in metres. */
export function gridSegments(origin: Vec3, gridSizeMm: number, roomExtentMm: number) {
  const cell = Math.max(1, gridSizeMm);
  const cells = Math.min(1200, Math.max(20, Math.ceil(Math.max(10000, roomExtentMm * 2) / cell)));
  const radius = cells * cell;
  const y = 0;
  const minor: number[] = [];
  const major: number[] = [];
  for (let index = -cells; index <= cells; index += 1) {
    const lines = index % 10 === 0 ? major : minor;
    const x = (origin[0] + index * cell) / 1000;
    const z = (origin[2] + index * cell) / 1000;
    lines.push(x, y, (origin[2] - radius) / 1000, x, y, (origin[2] + radius) / 1000);
    lines.push((origin[0] - radius) / 1000, y, z, (origin[0] + radius) / 1000, y, z);
  }
  return { minor, major };
}
